"use client";

import dynamic from "next/dynamic";
import type { VideoDubbingCardsBlockProps } from "./VideoDubbingCardsBlock";

const VideoDubbingCardsBlock = dynamic<VideoDubbingCardsBlockProps>(() =>
  import("./VideoDubbingCardsBlock").then(mod => mod.VideoDubbingCardsBlock),
);

export function VideoDubbingCardsBlockLazy(props: VideoDubbingCardsBlockProps) {
  return <VideoDubbingCardsBlock {...props} />;
}
